module.exports = __webpack_public_path__ + "static/media/bot-bg-mobile-low.4b0e9038.png";